// extracted by mini-css-extract-plugin
module.exports = {"tooltip-buttons":"tooltip_tooltip-buttons__3-ikY","show":"tooltip_show__2F0lw","tooltip-inner":"tooltip_tooltip-inner__25RbL","arrow":"tooltip_arrow__2JyEL"};